import type { OfflineCatalog } from './catalog';

/** Keep only projects whose offline download is complete (`ready`). */
export function offlineReadyProjects<T extends { id: string }>(projects: T[], catalog: OfflineCatalog): T[] {
  return projects.filter((p) => catalog[p.id]?.status === 'ready');
}

/** Case-insensitive substring filter by project name (empty query → all). */
export function filterProjectsByName<T extends { name: string }>(projects: T[], query: string): T[] {
  const q = query.trim().toLowerCase();
  if (!q) return projects;
  return projects.filter((p) => p.name.toLowerCase().includes(q));
}
